import type { Redirect } from '../../../../main/types/links';
import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_QR_CODE_LINK_ANDROID_REDIRECT = 'UPDATE_QR_CODE_LINK_ANDROID_REDIRECT' as const;

export const updateQrCodeLinkAndroidRedirect = (androidRedirect: Redirect) => ({
  data: { androidRedirect },
  type: UPDATE_QR_CODE_LINK_ANDROID_REDIRECT,
});

export type UpdateQrCodeLinkAndroidRedirectResponseAction = DataAction<
  typeof UPDATE_QR_CODE_LINK_ANDROID_REDIRECT,
  { androidRedirect: Redirect }
>;
